import { Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import Blogs from './Pages/Blogs/Blogs';
import AddProduct from './Pages/Dashboard/AddProduct';
import AddReview from './Pages/Dashboard/AddReview';
import Dashboard from './Pages/Dashboard/Dashboard';
import MakeAdmin from './Pages/Dashboard/MakeAdmin';
import ManageAllOrders from './Pages/Dashboard/ManageAllOrders';
import ManageProducts from './Pages/Dashboard/ManageProducts';
import MyOrders from './Pages/Dashboard/MyOrders';
import MyProfile from './Pages/Dashboard/MyProfile';
import Home from './Pages/Home/Home';
import Login from './Pages/Login/Login';
import RequireAdmin from './Pages/Login/RequireAdmin';
import RequireAuth from './Pages/Login/RequireAuth';
import SignUp from './Pages/Login/SignUp';
import MyPortfolio from './Pages/MyPortfolio/MyPortfolio';
import NotFound from './Pages/NotFound/NotFound';
import Purchase from './Pages/Purchase/Purchase';
import Footer from './Pages/Shared/Footer';
import Header from './Pages/Shared/Header';
import { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

function App() {

  useEffect(() => {
    AOS.init()
  }, [])

  return (
    <div style={{ backgroundColor: '#f2f4f6' }}>

      <Header></Header>

      <Routes>
        <Route
          path='/'
          element={
            <Home></Home>
          }
        ></Route>

        <Route
          path='/home'
          element={
            <Home></Home>
          }
        ></Route>

        <Route
          path='/parts/:id'
          element={
            <RequireAuth>
              <Purchase></Purchase>
            </RequireAuth>
          }
        ></Route>

        <Route
          path='/dashboard'
          element={
            <RequireAuth>
              <Dashboard></Dashboard>
            </RequireAuth>
          }
        >
          <Route
            index
            element={
              <MyProfile></MyProfile>
            }
          ></Route>

          <Route
            path="myOrders"
            element={
              <MyOrders></MyOrders>
            }
          ></Route>

          <Route
            path="addReview"
            element={
              <AddReview></AddReview>
            }
          ></Route>

          <Route
            path="manageAllOrders"
            element={
              <RequireAdmin>
                <ManageAllOrders></ManageAllOrders>
              </RequireAdmin>
            }
          ></Route>

          <Route
            path="addProduct"
            element={
              <RequireAdmin>
                <AddProduct></AddProduct>
              </RequireAdmin>
            }
          ></Route>

          <Route
            path="makeAdmin"
            element={
              <RequireAdmin>
                <MakeAdmin></MakeAdmin>
              </RequireAdmin>
            }
          ></Route>

          <Route
            path="manageProducts"
            element={
              <RequireAdmin>
                <ManageProducts></ManageProducts>
              </RequireAdmin>
            }
          ></Route>

        </Route>

        <Route
          path='/blogs'
          element={
            <Blogs></Blogs>
          }
        ></Route>

        <Route
          path='/portfolio'
          element={
            <MyPortfolio></MyPortfolio>
          }
        ></Route>

        <Route
          path='/login'
          element={
            <Login></Login>
          }
        ></Route>

        <Route
          path='/signup'
          element={
            <SignUp></SignUp>
          }
        ></Route>

        <Route
          path='*'
          element={
            <NotFound></NotFound>
          }
        ></Route>

      </Routes>

      <Footer></Footer>

      <ToastContainer />

    </div>
  );
}

export default App;
